(function($) {
	formHelper.addRule({
		form: '.form-tools-login',
		status: {
			SUCCESS: function() {
				this.redirect(this.data.redirectTo);
			}
		}
	});
})(jQuery);
